import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState, useEffect, useCallback } from 'react';
import { Button, Form, FormGroup, Label, Row, Col, Input, Spinner } from 'reactstrap';
import CommonSelect from '../../../Basic/Select';
import { getAllSecurityQuestionList, getUserSecurityQuestionList, setSecurityQuestion, checkAnswer } from '../../api';
import { withSection } from '../withSection';
var errorMessage = {
  noError: '',
  failed: 'SFxUserPreferencesNewSqFailed',
  incorrect: 'SFxUserPreferencesCheckAnswerError'
};
export var SecurityQuestion = withSection(function (props) {
  var prefix = props.prefix,
      userId = props.userId,
      userPreferencesCallback = props.userPreferencesCallback,
      trans = props.trans;
  var defaultQuestion = {
    label: '',
    value: '',
    Question: '',
    Id: ''
  };

  var _useState = useState(defaultQuestion),
      _useState2 = _slicedToArray(_useState, 2),
      currentQuestion = _useState2[0],
      setCurrentQuestion = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      currentQuestionAnswer = _useState4[0],
      setCurrentQuestionAnswer = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      currentQuestionNewAnswer = _useState6[0],
      setCurrentQuestionNewAnswer = _useState6[1];

  var _useState7 = useState(defaultQuestion),
      _useState8 = _slicedToArray(_useState7, 2),
      newQuestion = _useState8[0],
      setNewQuestion = _useState8[1];

  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      newQuestionAnswer = _useState10[0],
      setNewQuestionAnswer = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isCheckingAnswer = _useState12[0],
      setIsCheckingAnswer = _useState12[1];

  var _useState13 = useState('noError'),
      _useState14 = _slicedToArray(_useState13, 2),
      errorMessageType = _useState14[0],
      setErrorMessageType = _useState14[1];

  var _useState15 = useState(true),
      _useState16 = _slicedToArray(_useState15, 2),
      currentNewAnswerReadOnly = _useState16[0],
      setCurrentNewAnswerReadOnly = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      canSubmit = _useState18[0],
      setCanSubmit = _useState18[1];

  var _useState19 = useState([]),
      _useState20 = _slicedToArray(_useState19, 2),
      allQuestionList = _useState20[0],
      setAllQuestionList = _useState20[1];

  var _useState21 = useState([]),
      _useState22 = _slicedToArray(_useState21, 2),
      usedQuestionList = _useState22[0],
      setUsedQuestionList = _useState22[1];

  var _useState23 = useState([]),
      _useState24 = _slicedToArray(_useState23, 2),
      newQuestionList = _useState24[0],
      setNewQuestionList = _useState24[1];

  var _useState25 = useState(true),
      _useState26 = _slicedToArray(_useState25, 2),
      questionLoading = _useState26[0],
      setQuestionLoading = _useState26[1];

  var allSecurityQuestionList = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$getAllSecurity, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAllSecurityQuestionList();

          case 2:
            _yield$getAllSecurity = _context.sent;
            data = _yield$getAllSecurity.data;
            setAllQuestionList(data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), []);
  var userSecurityQuestionList = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _yield$getUserSecurit, data;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            setQuestionLoading(true);
            _context2.next = 3;
            return getUserSecurityQuestionList();

          case 3:
            _yield$getUserSecurit = _context2.sent;
            data = _yield$getUserSecurit.data;
            setUsedQuestionList(data);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), []);

  var checkAnswerHandler = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var param, _yield$checkAnswer, data;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(currentQuestionAnswer && currentQuestion && currentQuestion.value)) {
                _context3.next = 16;
                break;
              }

              setIsCheckingAnswer(true);
              setCurrentNewAnswerReadOnly(true);
              param = {
                userId: userId,
                answers: [{
                  QuestionId: currentQuestion.value,
                  Content: currentQuestionAnswer
                }]
              };
              _context3.prev = 4;
              _context3.next = 7;
              return checkAnswer(param, {
                catchError: true
              });

            case 7:
              _yield$checkAnswer = _context3.sent;
              data = _yield$checkAnswer.data;

              if (data.negativeQuestions > 0) {
                setErrorMessageType('incorrect');
              } else {
                setErrorMessageType('noError');
                setCurrentNewAnswerReadOnly(false);
              }

              _context3.next = 15;
              break;

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](4);
              setErrorMessageType('incorrect');

            case 15:
              setIsCheckingAnswer(false);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[4, 12]]);
    }));

    return function checkAnswerHandler() {
      return _ref3.apply(this, arguments);
    };
  }();

  var resetCurrentQuestion = function resetCurrentQuestion() {
    setCurrentQuestion(defaultQuestion);
    setCurrentQuestionNewAnswer('');
    setCurrentQuestionAnswer('');
  };

  var resetNewQuestion = function resetNewQuestion() {
    setNewQuestion(defaultQuestion);
    setNewQuestionAnswer('');
  };

  var onSubmitAnswer = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var param;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setCanSubmit(false);
              param = []; // add a new question

              if (newQuestion.value && newQuestionAnswer) {
                param.push({
                  QuestionId: newQuestion.value,
                  Content: newQuestionAnswer
                });
              } // change the old question answer


              if (currentQuestion.value && currentQuestionNewAnswer) {
                param.push({
                  QuestionId: currentQuestion.value,
                  Content: currentQuestionNewAnswer
                });
              } else {
                setErrorMessageType('noError');
                resetCurrentQuestion();
              }

              _context4.prev = 4;
              _context4.next = 7;
              return setSecurityQuestion(param, {
                catchError: true
              });

            case 7:
              setErrorMessageType('noError');
              resetCurrentQuestion();
              resetNewQuestion();
              userSecurityQuestionList();
              userPreferencesCallback({
                isSaveSQSuccess: 'success'
              });
              _context4.next = 20;
              break;

            case 14:
              _context4.prev = 14;
              _context4.t0 = _context4["catch"](4);
              resetCurrentQuestion();
              resetNewQuestion();
              setErrorMessageType('failed');
              userPreferencesCallback({
                isSaveSQSuccess: 'error'
              });

            case 20:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[4, 14]]);
    }));

    return function onSubmitAnswer() {
      return _ref4.apply(this, arguments);
    };
  }();

  useEffect(function () {
    allSecurityQuestionList();
    userSecurityQuestionList();
  }, [allSecurityQuestionList, userSecurityQuestionList]);
  useEffect(function () {
    if (allQuestionList.length) {
      var _newQuestionList = allQuestionList.filter(function (i) {
        return !usedQuestionList.find(function (j) {
          return i.Id === j.Id;
        }) && i;
      });

      setNewQuestionList(_newQuestionList);
      setQuestionLoading(false);
    }
  }, [allQuestionList, usedQuestionList]);
  useEffect(function () {
    var isValidCSQ = currentQuestionAnswer && currentQuestionNewAnswer && !!currentQuestion.Id && errorMessageType === 'noError';
    var isValidNSQ = newQuestion && newQuestion.Id && !!newQuestionAnswer;
    setCanSubmit(!!(isValidCSQ || isValidNSQ));
  }, [errorMessageType, currentQuestion, currentQuestionAnswer, currentQuestionNewAnswer, newQuestion, newQuestionAnswer]);
  useEffect(function () {
    setCurrentQuestionAnswer('');
    setCurrentQuestionNewAnswer('');
    setErrorMessageType('noError');
  }, [currentQuestion]);
  useEffect(function () {
    setNewQuestionAnswer('');
  }, [newQuestion]);
  return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, {
    form: true
  }, /*#__PURE__*/React.createElement(Col, {
    md: 8
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, trans('SFxUserPreferencesCurrentQsLabel')), /*#__PURE__*/React.createElement(CommonSelect, {
    renderOption: function renderOption(i) {
      return {
        label: i.Question,
        value: i.Id
      };
    },
    isDisabled: questionLoading,
    isLoading: questionLoading,
    value: currentQuestion,
    options: usedQuestionList,
    onChange: function onChange(item) {
      item && setCurrentQuestion(item);
    }
  })))), /*#__PURE__*/React.createElement(Row, {
    form: true
  }, /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(FormGroup, {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(Label, null, trans('SFxUserPreferencesCurrentAnswerLabel')), /*#__PURE__*/React.createElement(Input, {
    onChange: function onChange(e) {
      setCurrentQuestionAnswer(e.target.value);
    },
    name: "currentAnswer",
    onBlur: checkAnswerHandler,
    value: currentQuestionAnswer,
    maxLength: 1000
  }), isCheckingAnswer && /*#__PURE__*/React.createElement(Spinner, {
    style: {
      position: 'absolute',
      right: '10px',
      bottom: '12px'
    },
    size: "sm",
    color: "#fff"
  }))), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, trans('SFxUserPreferencesNewAnswerLabel')), /*#__PURE__*/React.createElement(Input, {
    readOnly: currentNewAnswerReadOnly,
    onChange: function onChange(e) {
      setCurrentQuestionNewAnswer(e.target.value);
    },
    name: "nweAnswer",
    value: currentQuestionNewAnswer,
    maxLength: 1000
  })))), /*#__PURE__*/React.createElement(Row, {
    form: true
  }, /*#__PURE__*/React.createElement(Col, {
    md: 8
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, trans('SFxUserPreferencesNewSqLabel')), /*#__PURE__*/React.createElement(CommonSelect, {
    renderOption: function renderOption(i) {
      return {
        label: i.Question,
        value: i.Id
      };
    },
    isDisabled: questionLoading,
    isLoading: questionLoading,
    value: newQuestion,
    options: newQuestionList,
    onChange: function onChange(item) {
      if (item) {
        setNewQuestion(item);
        resetCurrentQuestion();
        setErrorMessageType('noError');
      }
    }
  }))), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, trans('SFxUserPreferencesNewSqAnswerLabel')), /*#__PURE__*/React.createElement(Input, {
    onChange: function onChange(e) {
      setNewQuestionAnswer(e.target.value);
    },
    name: "Content",
    value: newQuestionAnswer,
    maxLength: 1000
  })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: "".concat(prefix, "-formValidErrorTip")
  }, trans(errorMessage[errorMessageType])))), /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    color: "primary",
    disabled: !canSubmit,
    onClick: onSubmitAnswer
  }, trans('SFxUserPreferencesSetSqText')));
});